import React, { useState, useEffect } from "react"; 
import { 
  Navbar, 
  Cart, 
  Home, 
  Gift, 
  Blog, 
  addBasketItem,  
  emptyBasket, 
  getBasketItems,
  updateItemQty,
  deleteBasketItem, 
  RegisterLogin,
  Orders,
  OrderPaid,
  AccountVerified,
  OrderDetails,
  Catalog,
  TicketForm, MyTickets, Ticket, Search, BlogPost} from "./components"; 
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Checkout from "./components/Checkout/Checkout";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { PrivateRoute } from "./components/PrivateRoute/PrivateRoute";
import ResetPassword from "./components/Auth/ResetPassword";
import { Brand } from "./components/Products/Brand";
import Footer from "./components/Footer/Footer";
import { ConfirmationSent } from "./components/Auth/ConfirmationSent";
import { DEV } from "./Env";

const wrapperStyle = {
  height : "100vh",
  overflow : "hidden"
}

const App = () => {
  const [searchOpen, setSearchOpen] = useState(false)
  const [cart, setCart] = useState([]);

  const cartQteReducer = (cart) => {
    let s =0 
    cart.forEach ( element => { 
      s += element.quantity 
    }) 
   
    return s
  };
  const handleFetchCart = async () => {
    setCart( await getBasketItems())
  };

  const handleUpdateCartQty = async (variantId, product, quantity, price, euroPrice) => { 
    setCart(await addBasketItem(variantId, product, quantity, price, euroPrice)); 
  };

  const handleQtychange = async (product,qty) => { 
    setCart(await updateItemQty(product,qty)); 
  };
   
  const handleRemoveFromCart = async (productId) => { 
    setCart(await deleteBasketItem(productId));
  };

  const handleEmptyCart = async () => {
    setCart(await emptyBasket() );
  };

  useEffect(  () => {
      //handleEmptyCart()
     handleFetchCart();
  }, []);

  return (
    <Router>
      <div style={searchOpen ? wrapperStyle : {}}>
        <Navbar totalItems= { cartQteReducer(cart)  } onSearchOpen={setSearchOpen} />
        <ScrollToTop />
        <Switch>
          <Route exact path="/">
            <Home  handleAddCart={handleUpdateCartQty}/>
          </Route>
          <Route exact path="/gift">
            <Gift />
          </Route>
          <Route exact path="/account/verified">
            <AccountVerified />
          </Route>
          <Route exact path="/account/confirmation-sent">
            <ConfirmationSent />
          </Route>
          <Route exact path="/checkout">
            <Checkout />
          </Route>
          <Route exact path="/products/:id">
            <Brand addToCart={handleUpdateCartQty}/>
          </Route>
          <Route exact path="/products">
            <Catalog/>
          </Route>
          <Route exact path="/blog">
            <Blog />
          </Route>
          <Route exact path="/blog/posts/:id">
            <BlogPost />
          </Route>
          <Route exact path="/auth/login">
            <RegisterLogin />
          </Route>
          <Route exact path="/auth/reset-password">
            <ResetPassword/>
          </Route>
          <Route exact path={"/auth"}>
            <Redirect to={"/auth/login"}></Redirect>
          </Route>
          <PrivateRoute exact path="/myorders">
            <Orders />
          </PrivateRoute>
          <PrivateRoute path="/orders/:orderId/completed">
            <OrderPaid/>
          </PrivateRoute>
          <PrivateRoute exact path="/orders/:orderId">
            <OrderDetails/>
          </PrivateRoute>
          <Route exact path="/support">
            <TicketForm/>
          </Route>
          <PrivateRoute exact path="/support/mytickets/:id">
            <Ticket/>
          </PrivateRoute>
          <PrivateRoute exact path="/support/mytickets">
            <MyTickets/>
          </PrivateRoute>
          <Route exact path="/cart">
            <Cart
              cart={cart}
              handleUpdateCartQty={handleQtychange}
              handleRemoveFromCart={handleRemoveFromCart}
              handleEmptyCart={handleEmptyCart} 
            />
          </Route>
        </Switch>
        <Footer />
        {searchOpen && <Search onSearchClose={setSearchOpen}/> }
      </div>
    </Router>
  );
};

export default App;
